<p [ngClass]="addClass">
  By clicking <strong>{{ linkText }}</strong
  >, you confirm that you have read, understand and agree to the Labcorp
  <a class="terms-link" [href]="effectiveTermsUrl" target="_blank">{{ effectiveTermsLinkText }}</a> and
  <a class="terms-link" [href]="privacyUrl" target="_blank">Privacy Policy</a>.
</p>
